import jQuery from 'jquery';
import initOdds from '../oddsTabHandler';

// default variant of odds tab
const variant0 = () => {
    jQuery('.js-odds-variant0').show();

    // if we are on odds tab
    if (jQuery('.js-RC-oddsCard').length) {
        initOdds();
    }
};

export default variant0;



// WEBPACK FOOTER //
// ./lib/js/modules/odds/variant0.js